import React, { ChangeEventHandler } from 'react';
import { CountryInput, CountryListProps } from '@paypalcorp/pp-react';
import { useNavigate, useParams } from 'react-router';
import { trackFieldChange, trackFieldFocus } from '../../../lib/fpti';
import { FIELD_NAMES } from '../../../lib/constants';

interface CountryDropdownProps {
  countryList: Array<CountryListProps>;
}

const CountryDropdown = ({ countryList }: CountryDropdownProps) => {
  const navigate = useNavigate();
  const { page, country, subPage } = useParams();

  const updateCountry: ChangeEventHandler<HTMLInputElement> = (evt) => {
    const countryCode = evt.target.value;
    const selectedCountry = countryList.find((country) => country.countryCode === countryCode);
    trackFieldChange(FIELD_NAMES.COUNTRY_SELECTOR, selectedCountry?.label);
    navigate(
      `/checkout/pay-later/${evt.target.value.toLowerCase()}${page ? `/${page}` : ''}${
        subPage ? `/${subPage}` : ''
      }`
    );
  };

  return (
    <CountryInput
      countryList={countryList}
      name="country-input"
      value={country?.toUpperCase()}
      onFocus={() => trackFieldFocus(FIELD_NAMES.COUNTRY_SELECTOR)}
      onChange={updateCountry}
    />
  );
};

export default CountryDropdown;
